<template>
  <div id="BLOOD" class="print-content">
    <div style="margin-top: 20px">
      <div style="display: flex; flex-direction: column; align-items: center">
        <span style="font-size: 38px; font-weight: 800">
          مستشفى الوزيرية الاهلي</span
        >
        <span style="font-size: 38px; font-weight: 800"> مصرف الدم</span>
        <span
          style="font-size: 38px; font-weight: 800; text-decoration: underline"
        >
          تقرير المطابقة
        </span>
      </div>

      <div
        style="
          display: flex;
          flex-direction: column;
          text-wrap: nowrap;
          margin-top: 30px;
          margin-bottom: 30px;
        "
      >
      <span
          
          style="
            font-size: 38px;
            font-weight: 800;
            margin-left: 800px;
            margin-top: 10px;
            text-align: right;
          "
        >
          {{ date }} : التاريخ
        </span>
        <span
          v-if="data.length == 1"
          style="
            font-size: 38px;
            font-weight: 800;
            margin-left: 800px;
            margin-top: 10px;
            text-align: right;
          "
        >
          {{ data[0].blood_bottle.production_date }} : تاريخ الانتاج
        </span>
        <span
          v-if="data.length == 1"
          style="
            font-size: 38px;
            font-weight: 800;
            margin-left: 800px;
            margin-top: 10px;
            text-align: right;
          "
        >
          {{ data[0].blood_bottle.expiration_date }} : تاريخ النفاذ
        </span>

        <span
          style="
            font-size: 38px;
            font-weight: 800;
            margin-left: 800px;
            margin-top: 10px;
            text-align: right;
          "
        >
          اسم المريض : {{ this.$route.params.patient_name }}
        </span>
        <span
          style="
            font-size: 38px;
            font-weight: 800;
            margin-left: 800px;
            margin-top: 10px;
            text-align: right;
          "
        >
          {{ `(${data[0].blood_bottle.abo})` + " " + data[0].blood_bottle.rh }}
          :صنف الدم
        </span>
      </div>

      <table
        style="
          width: 100%;
          border-collapse: collapse;
          margin: 20px auto;
          overflow: hidden;
          border: 3px solid black;
        "
      >
        <tr>
          <th
            style="
              padding: 8px;
              text-align: center;
              background-color: #848884;
              border-bottom: 1px solid;
              border-right: 1px solid;
            "
          >
            <div
              style="
                display: flex;
                justify-content: space-between;
                color: white;
              "
            >
              <span style="font-size: 33px; font-weight: 600">Bottle #</span>
            </div>
          </th>
          <th
            style="
              padding: 8px;
              text-align: center;
              border-bottom: 1px solid;
              background-color: #848884;
              border-right: 1px solid;
            "
          >
            <div
              style="
                display: flex;
                justify-content: space-between;
                color: white;
              "
            >
              <span style="font-size: 33px; font-weight: 600">ABO</span>
            </div>
          </th>
          <th
            style="
              padding: 8px;
              text-align: center;
              background-color: #848884;
              border-bottom: 1px solid;
              border-left: 1px solid;
            "
          >
            <div
              style="
                display: flex;
                justify-content: space-between;
                color: white;
              "
            >
              <span style="font-size: 33px; font-weight: 600">RH</span>
            </div>
          </th>

          <th
            style="
              padding: 8px;
              text-align: center;
              background-color: #848884;
              border-bottom: 1px solid;
              border-left: 1px solid;
            "
          >
            <div
              style="
                display: flex;
                justify-content: space-between;
                color: white;
              "
            >
              <span style="font-size: 33px; font-weight: 600">R.T</span>
            </div>
          </th>
          <th
            style="
              padding: 8px;
              text-align: center;
              background-color: #848884;
              border-bottom: 1px solid;
              border-left: 1px solid;
            "
          >
            <div
              style="
                display: flex;
                justify-content: space-between;
                color: white;
              "
            >
              <span style="font-size: 33px; font-weight: 600">37C</span>
            </div>
          </th>

          <th
            style="
              padding: 8px;
              text-align: center;
              background-color: #848884;
              border-bottom: 1px solid;
              border-left: 1px solid;
            "
          >
            <div
              style="
                display: flex;
                justify-content: space-between;
                color: white;
              "
            >
              <span style="font-size: 33px; font-weight: 600">A.H.G</span>
            </div>
          </th>

          <th
            style="
              padding: 8px;
              text-align: center;
              background-color: #848884;
              border-bottom: 1px solid;
              border-left: 1px solid;
            "
          >
            <div
              style="
                display: flex;
                justify-content: space-between;
                color: white;
              "
            >
              <span style="font-size: 33px; font-weight: 600">N.B</span>
            </div>
          </th>
          <th
            v-if="data.length > 1"
            style="
              padding: 8px;
              text-align: center;
              background-color: #848884;
              border-bottom: 1px solid;
              border-left: 1px solid;
            "
          >
            <div
              style="
                display: flex;
                justify-content: space-between;
                color: white;
              "
            >
              <span style="font-size: 33px; font-weight: 600">Prod. Date</span>
            </div>
          </th>

          <th
            v-if="data.length > 1"
            style="
              padding: 8px;
              text-align: center;
              background-color: #848884;
              border-bottom: 1px solid;
              border-left: 1px solid;
            "
          >
            <div
              style="
                display: flex;
                justify-content: space-between;
                color: white;
              "
            >
              <span style="font-size: 33px; font-weight: 600">Exp. Date</span>
            </div>
          </th>
        </tr>
        <tbody>
          <template v-for="(row, j) in data">
            <tr>
              <td
                style="
                  padding: 8px;
                  text-align: center;
                  width: 400px;
                  border-bottom: 1px solid #333;
                  border-right: 1px solid #333;
                  font-size: 33px;
                "
              >
                {{ row.blood_bottle.bottle_identifier }}
              </td>
              <td
                style="
                  padding: 8px;
                  text-align: center;
                  border-bottom: 1px solid #333;
                  border-left: 1px solid #333;
                  border-right: 1px solid #333;
                  font-size: 33px;
                  width: 150px;
                "
              >
                {{ row.blood_bottle.abo }}
              </td>
              <td
                style="
                  padding: 8px;
                  text-align: center;
                  border-bottom: 1px solid #333;
                  border-left: 1px solid #333;
                  border-right: 1px solid #333;
                  font-size: 33px;
                  width: 150px;
                "
              >
                {{ row.blood_bottle.rh }}
              </td>

              <td
                style="
                  padding: 8px;
                  text-align: center;
                  border-bottom: 1px solid;
                  border-left: 1px solid;
                  border-right: 1px solid;
                  font-size: 33px;
                  width: 150px;
                "
              >
                {{ row.room_temperature === 0 ? "Null" : "Abnormal" }}
              </td>

              <td
                style="
                  padding: 8px;
                  text-align: center;
                  border-bottom: 1px solid;
                  border-left: 1px solid;
                  border-right: 1px solid;
                  font-size: 33px;
                  width: 150px;
                "
              >
                {{ row.incubator_temperature === 0 ? "Null" : "Abnormal" }}
              </td>

              <td
                style="
                  padding: 8px;
                  text-align: center;
                  border-bottom: 1px solid;
                  border-left: 1px solid;
                  border-right: 1px solid;
                  font-size: 33px;
                  width: 150px;
                "
              >
                {{ row.anti_human_globulin === 'compatible' ? "Null" : "Abnormal" }}
              </td>

              <td
                style="
                  padding: 8px;
                  text-align: center;
                  border-bottom: 1px solid;
                  border-left: 1px solid;
                  border-right: 1px solid;
                  font-size: 33px;
                  width: 150px;
                "
              >
                {{ row.final_result }}
              </td>
              <td
                v-if="data.length > 1"
                style="
                  padding: 8px;
                  text-align: center;
                  border-bottom: 1px solid;
                  border-left: 1px solid;
                  border-right: 1px solid;
                  font-size: 33px;
                  text-wrap: nowrap;
                "
              >
                {{ row.blood_bottle.production_date }}
              </td>

              <td
                v-if="data.length > 1"
                style="
                  padding: 8px;
                  text-align: center;
                  border-bottom: 1px solid;
                  border-left: 1px solid;
                  border-right: 1px solid;
                  font-size: 33px;
                  text-wrap: nowrap;
                "
              >
                {{ row.blood_bottle.expiration_date }}
              </td>
            </tr>
          </template>
        </tbody>
      </table>
      <div
        style="
          display: flex;
          justify-content: space-between;
          margin-top: 500px;
          padding: 100px;
        "
      >
        <span style="font-size: 33px; font-weight: 600">تاريخ الفحص</span>
        <span style="font-size: 33px; font-weight: 600"
          >الاسم و توقيع الفاحص</span
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  computed: {
    date() {
      return new Date().toLocaleDateString("en-IQ", {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
      });
    },
  },
};
</script>
<style scoped>
.print-content {
  display: none;
}

.rtl {
  direction: rtl;
}

.ltr {
  direction: ltr;
}

/* Show the print content when printing */
@media print {
  .print-content {
    display: block;
  }

  button {
    display: none;
    /* Hide the button when printing */
  }
}

p.solid {
  border-style: solid;
}

table {
  background-color: #333;
  width: 60%;
  border-collapse: separate;
  border-spacing: 0;
  margin: 20px auto;
  border-radius: 10px;
  overflow: hidden;
  border: 3px solid #333;
}

th,
td {
  padding: 8px;
  text-align: center;
  border-bottom: 1px solid #333;
}

th {
  background-color: #f2f2f2;
}

tr:last-child td {
  border-bottom: none;
}
</style>
<!--  -->
